import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row,	Col, FormGroup, Label, Input, Badge } from 'reactstrap';
import IntlMessage from '../../../../../helpers/intlMessage';
import './informacoes.laudo.modal.styles.css';

class InformacoeslaudoModal extends Component {
  render() {
    return (
      	<div className='mv-container-informacoes-laudo'>
			<Modal size='xl' isOpen={this.props.isOpen} toggle={this.props.toggle}>
				<ModalHeader>
					<IntlMessage id = "dashboards.doctorTasks.reportDetails"/> - {`${this.props.laudo}`}
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.attendance" />
								</Label>
								<Input
									value={this.props.detalhesLaudo.nrAtendimento}
									disabled={true}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetails.attendanceType" />
								</Label>
								<Input
									required
									minLength={10}
									disabled={true}
									value={this.props.detalhesLaudo.tipoAtendimento}
								/>
							</FormGroup>
						</Col>
						<Col xs={6}>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.serviceUnit" />
								</Label>
								<Input
									minLength={10}
									disabled={true}
									value={this.props.detalhesLaudo.unidadeOrigemAtendimento}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetails.attendanceDate" />
								</Label>
								<Input
									minLength={10}
									disabled={true}
									value={this.props.detalhesLaudo.dataAtendimento}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetails.expectedDeliveryDate" />
								</Label>
								<Input
									value={this.props.detalhesLaudo.dataEntregaPrevista}
									disabled={true}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.reports.deliveryDate" />
								</Label>
								<Input
									value={this.props.detalhesLaudo.dataEntrega}
									disabled={true}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.releaseDate" />
								</Label>
								<Input
									minLength={10}
									disabled={true}
									value={this.props.detalhesLaudo.dataLiberacao}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetails.PatientSSN"/>
								</Label>
								<Input
									value={this.props.detalhesLaudo.pacienteCpf}
									disabled={true}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.requestingSector" />
								</Label>
								<Input
									value={this.props.detalhesLaudo.setorSolicitante}
									disabled={true}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.requestingDoctor" />
								</Label>
								<Input
									value={this.props.detalhesLaudo.medico}
									disabled={true}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.healthInsurance" />
								</Label>
								<Input
									minLength={10}
									disabled={true}
									value={this.props.detalhesLaudo.convenio}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetail.previousReport" />
								</Label>
								<Input
									value={this.props.detalhesLaudo.laudoAnterior}
									disabled={true}
								/>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="Ac Number" />
								</Label>
								<Input
									minLength={10}
									disabled={true}
									value={this.props.detalhesLaudo.acNumber}
								/>
							</FormGroup>
						</Col>
					</Row>
					{this.props.frascos.length > 0 && (
						<div className='informacoes-laudo'>
							<Row>
								<Col>
									<div className='sessao'>
										<div>
											<Label><IntlMessage id="general.materialArchiving.material" ></IntlMessage></Label>
										</div>
										<div className='separador'></div>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<FormGroup>
										<Label>
											<IntlMessage id="dashboards.examDetails.microscopist" />
										</Label>
										<Input
											value={this.props.detalhesLaudo.nomeMedicoMicro}
											disabled={true}
										/>
									</FormGroup>
								</Col>
								<Col>
									<FormGroup>
										<Label>
											<IntlMessage id="dashboards.examDetail.receivedBy" />
										</Label>
										<Input
											value={this.props.detalhesLaudo.usuarioRecebimento}
											disabled={true}
										/>
									</FormGroup>
								</Col>
								<Col>
									<FormGroup>
										<Label>
											<IntlMessage id="dashboards.disposalMaterials.table.deliveryDate" />
										</Label>
										<Input
											disabled={true}
											value={this.props.detalhesLaudo.dataEntrega}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col>
								{this.props.frascos.map((f, i) => (
									<Badge key={i} color="primary" className="badge badge-info badge-material">
										<Badge color="link">{f.topografia} ({f.status})</Badge>
										<Badge color="dark"> <IntlMessage id="dashboards.reports.bottle"/> {f.dsFrasco}</Badge>
									</Badge>
								))}
								</Col>
							</Row>
						</div>
					)}
				</ModalBody>
				<ModalFooter>
					<Button
						className='modalComponente-fechar'
						color='secondary'
						onClick={this.props.toggle}
					>
						<IntlMessage id = "dashboards.examDetail.close"/>
					</Button>
				</ModalFooter>
			</Modal>
      	</div>
    );
  }
}


const mapDispacthToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(null, mapDispacthToProps)(InformacoeslaudoModal);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/informacoes_laudo/informacoes.laudo.modal.js